import React, { Fragment, useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'

export default function Lobby() {
    const { t } = useTranslation()
    const tokensave = sessionStorage.getItem('jwt')

    const {user} = useSelector(state=>state.users)

    const [token, setToken] = useState()
    const [isSuperadmin, setIsSuperadmin] = useState()
    const [isClient, setIsClient] = useState()
    const [isClub, setIsClub] = useState()
    const [club, setClub] = useState(null)
    const [multipleClubs, setMultipleClubs] = useState(false)

    const updateSessionStorage = (newValues) => {
		const currentData = JSON.parse(sessionStorage.getItem('dataSdplay')) || {}
		const updatedData = { ...currentData, ...newValues }
		sessionStorage.setItem('dataSdplay', JSON.stringify(updatedData))
	}

    useEffect(() =>{
        if(tokensave){
            setToken(jwtDecode(tokensave))
        }
    }, [tokensave])

    useEffect(() =>{
        if(token){
            setIsSuperadmin(token.roles.some(role => role.profileType === 'Superadmin'))
            setIsClient(token.roles.some(role => role.profileType === 'Client'))

            let clubRoles = token.roles.filter(role => role.profileType === 'Club')
            setIsClub(clubRoles.length > 0)
            setMultipleClubs(clubRoles.length > 1)
            if(clubRoles.length === 1){
                setClub(clubRoles[0].profile._id)
            }
        }
    }, [token])

    return (
        <Fragment>
            <header className="cabecera d-flex align-items-center px-4">
                <Link to='/'><img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" height={28} /></Link>
            </header>
            <Container className='p-5'>
                <div className="page-header">
                    <p className="page-subtitle">{t('lobby.dashboard.welcome')}</p>
                    <h1>{user?.firstname}</h1>
                </div>
                <Row className="g-4">
                    {isClient ?
                        <Col xs={12} sm={6} lg={3}>
                            <Link to={`/${t("url.client.client")}/${t("url.client.dashboard")}`} className="text-decoration-none">
                                <div className="nav-card p-4 text-center">
                                    <div className="kpi-icon mx-auto mb-3">
                                        <img src="/images/athlete.png" alt="athlete" width={32} />
                                    </div>
                                    <h3 className="mb-0">{t('lobby.dashboard.client')}</h3>
                                </div>
                            </Link>
                        </Col>
                    : ''}
                    {multipleClubs ?
                        <Col xs={12} sm={6} lg={3}>
                            <Link to={`/${t("url.club.club")}/${t("url.club.lobby")}`} className="text-decoration-none">
                                <div className="nav-card p-4 text-center">
                                    <div className="kpi-icon mx-auto mb-3">
                                        <img src="/images/shield.png" alt="club" width={32} />
                                    </div>
                                    <h3 className="mb-0">{t('lobby.dashboard.club')}</h3>
                                </div>
                            </Link>
                        </Col>
                    : isClub ?
                        <Col xs={12} sm={6} lg={3}>
                            <Link onClick={() => updateSessionStorage({ clubId: club })} to={`/${t("url.club.club")}/${t("url.club.dashboard")}`} className="text-decoration-none">
                                <div className="nav-card p-4 text-center">
                                    <div className="kpi-icon mx-auto mb-3">
                                        <img src="/images/shield.png" alt="club" width={32} />
                                    </div>
                                    <h3 className="mb-0">{t('lobby.dashboard.club')}</h3>
                                </div>
                            </Link>
                        </Col>
                    : ''}
                    {isSuperadmin ?
                        <Col xs={12} sm={6} lg={3}>
                            <Link to={`/${t("url.admin.admin")}/${t("url.admin.dashboard")}`} className="text-decoration-none">
                                <div className="nav-card p-4 text-center">
                                    <div className="kpi-icon mx-auto mb-3">
                                        <img src="/images/admin.png" alt="admin" width={32} />
                                    </div>
                                    <h3 className="mb-0">{t('lobby.dashboard.admin')}</h3>
                                </div>
                            </Link>
                        </Col>
                    : ''}
                </Row>
            </Container>
        </Fragment>
    )
}